export const UPDATE_LOADING_MEMBER_CREATE = "UPDATE_LOADING_MEMBER_CREATE"
export const ADD_NEW_QUESTION_MEMBER_CREATE = "ADD_NEW_QUESTION_MEMBER_CREATE"
export const CLEAR_CREATE_QUESTION_REQUEST_MEMBER = "CLEAR_CREATE_QUESTION_REQUEST_MEMBER"
export const GET_MEMBER_DATA = "GET_MEMBER_DATA"
export const UPDATE_TAB_SETTING_MEMBER_CREATE = "UPDATE_TAB_SETTING_MEMBER_CREATE"
export const UPDATE_MEMBER_REQUEST = "UPDATE_MEMBER_REQUEST"
export const UPDATE_MEMBER_CREATE_CODE = "UPDATE_MEMBER_CREATE_CODE"
export const UPDATE_MEMBER_THEME = "UPDATE_MEMBER_THEME"
export const UPDATE_CURRENT_PAGE_INDEX = "UPDATE_CURRENT_PAGE_INDEX"